module.exports = __webpack_public_path__ + "static/img/wechat.4214036.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wechat.jpeg
// module id = ja2c
// module chunks = 1